import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const SubSectionKPIIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros específica para SubSectionKPI
    const filterConfig = useMemo(() => [        
        {
            type: "text",
            name: "refNumber",
            label: "Ref Number",
            placeholder: "Ref Number..."
        },
        {
            type: "text",
            name: "columnName",
            label: "Column Name",
            placeholder: "Column Name..."
        },
        {
            type: "text",
            name: "subSectionDescription",
            label: "Sub Section",
            placeholder: "Sub Section..."
        },
        {
            type: "text",
            name: "kpiDescription",
            label: "KPI Description",
            placeholder: "KPI Description..."
        }
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        { 
            title: 'Sub Section', 
            dataIndex: 'subSection.description', 
            key: 'subSection.description', 
            sortable: true 
        },
        { 
            title: 'Ref Number', 
            dataIndex: 'refNumber', 
            key: 'refNumber', 
            sortable: true, 
            width: 130 
        },
        { 
            title: 'KPI', 
            dataIndex: 'kpi.description', 
            key: 'kpi.description', 
            sortable: true, 
            width: 200 
        },
        { 
            title: 'Column Row', 
            dataIndex: 'column.name', 
            key: 'column.name', 
            sortable: true 
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 80,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/subSectionKPI/edit/${record.subSectionKPIID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="SubSectionKPI"
            apiEndpoint="/SubSectionKPI/getAllPaginated"
            toggleActiveEndpoint="/subSectionKPI/toggleActive"
            toggleDeletedEndpoint="/subSectionKPI/toggleDeleted"
            newRoute="/subSectionKPI/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="subSectionKPIID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default SubSectionKPIIndex;
